var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"caption"},[_vm._v(" "+_vm._s((_vm.time / (60 * 60)).toFixed(2))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }